/* eslint-disable */
/**
 *  use https://docs.google.com/spreadsheets/d/1NXsv5FwrfjQlORSRp9atW9IJp28zpM09ySGvOoVft88/edit?usp=sharing
 * for translation help
 */

export default {
	en: {
		error: 'error',
		warning: 'warning',
		info: 'information',
		langModalMsg: 'Select your language',
		fontSizeModalMsg: 'Font-Size',
		colorModeModalMsg: 'Color Mode',
		smaller: 'Small',
		medium: 'Medium',
		larger: 'Large',
		largest: 'Larger',
		content_new: 'New content nearby! Click here to view.',
		content_current: 'Viewing nearby content.',
		toast_wrongCode: 'Sorry, no such station.',
		loading_text: 'Loading content...',
		syncaudio_bar_text: 'Synchronising audio...',
		toast_noAR: 'There is no AR support built in. Please use the native app!',
		back: 'Back',
		cancel: 'Cancel',
		close: 'close',
		ok: 'OK',
		volumeUp: 'up',
		volumeDown: 'down',
		keyPadStationNumber: 'Enter number',
		keyPadEnterNumber: 'Enter number',
		keyPadWrongNumber: 'Number not found',
		minutes: 'minutes',
		seconds: 'seconds',
		close: 'close',
		play: 'play',
		pause: 'pause',
		show: 'show',
		hide: 'hide',
		delete: 'delete',
		transcriptButtonTitle: 'Audio as text',
		homeButton: 'home',
		exhibitionsButton: 'exhibition overview',
		backToAr: 'camera',
		navUpButton: 'up',
		navNextButton: 'next',
		navPreButton: 'previous',
		searchButton: 'keypad',
		languageSwitch: 'language selection',
		mapButton: 'map',
		next: 'next',
		previous: 'previous',
		restart: 'restart app',
		clear: 'clear',
		toggle: 'toggle',
		refresh: 'Update view ...',
		skip: 'skip',
		previous: 'back',
		next: 'continue',
		end: 'end',
		download: 'download',
		downloading: 'downloading',
		waiting: 'waiting',
		update: 'update',
		share: 'share',
		proceed: 'proceed',
		arWarningHeader: 'Pay attention to your surroundings!',
		arWarningText: 'Do not use Augmented Reality in any way that distracts you from real-world situations.',
		arWarningSubText: 'Children are to use Augmented Reality only under adult supervision.',
		arCoreKitWarningHeader: 'Attention',
		arCoreKitWarningText: 'Please note that your device is not AR Kit/Core capable. Therefore, the use of augmented reality is unfortunately not possible.',
		understood: 'I understand',
		noEntriesFound: 'No entries found.',
		bright: 'Bright',
		dark: 'Dark',
		downloadConfirmationMessage: 'Are you sure you want to download ?',
		yes: 'Yes',
		no: 'No',
	},
	de: {
		error: 'Fehler',
		warning: 'Warnung',
		info: 'Information',
		langModalMsg: 'Wählen Sie Ihre Sprache.',
		fontSizeModalMsg: 'Schriftgröße',
		colorModeModalMsg: 'Farbmodus',
		smaller: 'Klein',
		medium: 'Mittel',
		larger: 'Groß',
		largest: 'Größer',
		content_new: 'Neue Inhalte in der Nähe! Hier klicken zum Ansehen.',
		content_current: 'Aktueller Inhalt wird angezeigt.',
		toast_wrongCode: 'Entschuldigung. Zu dieser Nummer gibt es keine Station.',
		loading_text: 'Lade Inhalt...',
		syncaudio_bar_text: 'Synchronisiere Audio...',
		toast_noAR: 'AR Inhalte werden nicht unterstützt. Bitte benutzen Sie die native App.',
		back: 'Zurück',
		cancel: 'Abbrechen',
		close: 'Schließen',
		ok: 'OK',
		volumeUp: 'Lauter',
		volumeDown: 'Leiser',
		keyPadStationNumber: 'Nummer eingeben',
		keyPadEnterNumber: 'Nummer eingeben',
		keyPadWrongNumber: 'Nummer nicht gefunden',
		minutes: 'Minuten',
		seconds: 'Sekunden',
		play: 'Spiele',
		pause: 'Pausiere',
		show: 'Zeige',
		hide: 'Verstecke',
		delete: 'Löschen',
		transcriptButtonTitle: 'Audio als Text',
		next: 'Weiter',
		previous: 'Zurück',
		restart: 'App neu starten',
		clear: 'Löschen',
		toggle: 'Umschalten',
		refresh: 'Ansicht aktualisieren ...',
		skip: 'Überspringen',
		previous: 'Zurück',
		next: 'Weiter',
		end: 'Beenden',
		download: 'Herunterladen',
		downloading: 'Wird geladen',
		waiting: 'Warte',
		update: 'Update',
		share: 'Teilen',
		arWarningHeader: 'Achte auf deine Umgebung!',
		arWarningText:
			'Verwende Augmented Reality nicht, wenn Du Dich in Situationen befindest, in denen eine derartige Ablenkung Dich davon abhält, Deine reale Umgebung wahrzunehmen.',
		arWarningSubText: 'Kinder dürfen Augmented Reality nur unter Aufsicht von Erwachsenen verwenden.',
		arCoreKitWarningHeader: 'Achtung!',
		arCoreKitWarningText: 'Bitte beachten Sie, dass Ihr Gerät nicht AR Kit/Core fähig ist. Eine Nutzung von Augmented Reality ist deshalb leider nicht möglich.',
		understood: 'Verstanden',
		noEntriesFound: 'Keine Einträge gefunden.',
		bright: 'Hell',
		dark: 'Dunkel',
		downloadConfirmationMessage: 'Sind Sie sicher, dass Sie Folgendes herunterladen möchten ?',
		yes: 'Ja',
		no: 'Nein',
	},
	des: {
		langModalMsg: 'Wählen Sie Ihre Sprache',
		fontSizeModalMsg: 'Schriftgröße',
		colorModeModalMsg: 'Farbmodus',
		smaller: 'Klein',
		medium: 'Mittel',
		larger: 'Groß',
		largest: 'Größer',
		content_new: 'Neue Inhalte in der Nähe! Hier klicken zum Ansehen.',
		content_current: 'Aktueller Inhalt wird angezeigt.',
		toast_wrongCode: 'Entschuldigung. Zu dieser Nummer gibt es kein Exponat.',
		loading_text: 'Lade Inhalt...',
		syncaudio_bar_text: 'Audio wird angeglichen...',
		toast_noAR: 'AR Inhalte werden nicht unterstüzt. Bitte benutzen Sie die native App.',
		back: 'Zurück',
		cancel: 'Abbrechen',
		close: 'schließen',
		ok: 'OK',
		volumeUp: 'Lauter',
		volumeDown: 'Leiser',
		keyPadStationNumber: 'Nummer eingeben',
		keyPadEnterNumber: 'Nummer eingeben',
		keyPadWrongNumber: 'Nummer nicht gefunden',
		minutes: 'Minuten',
		seconds: 'Sekunden',
		play: 'Spiele',
		pause: 'Pausiere',
		show: 'Zeige',
		hide: 'Verstecke',
		delete: 'Löschen',
		transcriptButtonTitle: 'Audio als Text',
		next: 'Weiter',
		previous: 'Zurück',
		restart: 'App neu starten',
		clear: 'Löschen',
		toggle: 'Umschalten',
		skip: 'Überspringen',
		previous: 'Zurück',
		next: 'Weiter',
		end: 'Starten',
		download: 'Herunterladen',
		downloading: 'Wird geladen',
		waiting: 'Warte',
		update: 'Update',
		share: 'Teilen',
		arWarningHeader: 'Achte auf deine Umgebung!',
		arWarningText:
			'Verwende Augmented Reality nicht, wenn Du Dich in Situationen befindest, in denen eine derartige Ablenkung Dich davon abhält, Deine reale Umgebung wahrzunehmen.',
		arWarningSubText: 'Kinder dürfen Augmented Reality nur unter Aufsicht von Erwachsenen verwenden.',
		understood: 'Verstanden',
		noEntriesFound: 'Keine Einträge gefunden.',
		bright: 'Hell',
		dark: 'Dunkel',
	},
	dec: {
		langModalMsg: 'Wählen Sie Ihre Sprache',
		fontSizeModalMsg: 'Schriftgröße',
		colorModeModalMsg: 'Farbmodus',
		smaller: 'Klein',
		medium: 'Mittel',
		larger: 'Groß',
		largest: 'Größer',
		content_new: 'Neue Inhalte in der Nähe! Hier klicken zum Ansehen.',
		content_current: 'Aktueller Inhalt wird angezeigt.',
		toast_wrongCode: 'Entschuldigung. Zu dieser Nummer gibt es kein Exponat.',
		loading_text: 'Lade Inhalt...',
		syncaudio_bar_text: 'Audio wird angeglichen...',
		toast_noAR: 'AR Inhalte werden nicht unterstüzt. Bitte benutzen Sie die native App.',
		back: 'Zurück',
		cancel: 'Abbrechen',
		close: 'schließen',
		ok: 'OK',
		volumeUp: 'lauter',
		volumeDown: 'leiser',
		keyPadStationNumber: 'Nummer eingeben',
		keyPadWrongNumber: 'Nummer nicht gefunden',
		keyPadEnterNumber: 'Nummer eingeben',
		minutes: 'Minuten',
		seconds: 'Sekunden',
		play: 'spiele',
		pause: 'pausiere',
		show: 'zeige',
		hide: 'verstecke',
		delete: 'löschen',
		transcriptButtonTitle: 'Audio als Text',
		next: 'weiter',
		previous: 'zurück',
		restart: 'App neu starten',
		clear: 'löschen',
		toggle: 'umschalten',
		skip: 'überspringen',
		previous: 'zurück',
		next: 'weiter',
		end: 'starten',
		share: 'teilen',
		arWarningHeader: 'Achte auf deine Umgebung!',
		arWarningText:
			'Verwende Augmented Reality nicht, wenn Du Dich in Situationen befindest, in denen eine derartige Ablenkung Dich davon abhält, Deine reale Umgebung wahrzunehmen.',
		arWarningSubText: 'Kinder dürfen Augmented Reality nur unter Aufsicht von Erwachsenen verwenden.',
		understood: 'verstanden',
		noEntriesFound: 'Keine Einträge gefunden.',
		bright: 'Hell',
		dark: 'Dunkel',
	},
	es: {
		keyPadStationNumber: 'Introduce el número',
		keyPadEnterNumber: 'Número de objeto',
	},
	nl: {
		langModalMsg: 'Kies uw taal.',
		fontSizeModalMsg: 'Lettergrootte',
		colorModeModalMsg: 'Kleurmodus',
		smaller: 'Small',
		medium: 'Medium',
		larger: 'Groot',
		largest: 'Groter',
		content_new: 'Nieuwe inhoud in de buurt! Klik hier om het te zien.',
		content_current: 'Huidige inhoud wordt weergegeven.',
		toast_wrongCode: 'Sorry. Er is geen station voor dit nummer.',
		loading_text: 'Inhoud laden ...',
		syncaudio_bar_text: 'Audio synchroniseren ...',
		toast_noAR: 'AR-inhoud wordt niet ondersteund. Gebruik alstublieft de native app!',
		back: 'Terug',
		cancel: 'Annuleren',
		ok: 'OK',
		keyPadStationNumber: 'Voer nummer in',
		keyPadEnterNumber: 'Voer aantal in',
		keyPadWrongNumber: 'Nummer niet gevonden',
		minutes: 'minuten',
		seconds: 'seconden',
		play: 'spelen',
		pause: 'pauze',
		show: 'toon',
		close: 'dichtbij',
		hide: 'verbergen',
		transcriptButtonTitle: 'Audio als tekst',
		next: 'volgende',
		previous: 'voorgaand',
		skip: 'overspringen',
		previous: 'terug',
		next: 'doorgaan met',
		end: 'doorgaan met',
		arWarningHeader: 'Let op uw omgeving!',
		arWarningText:
			'Gebruik Augmented Reality niet als je in situaties zit waarin een dergelijke afleiding je verhindert om je echte omgeving waar te nemen.',
		understood: 'Ik begrijp het.',
		bright: 'Licht',
		dark: 'Donker',
	},
	fr: {
		langModalMsg: 'Choisissez votre langue',
		fontSizeModalMsg: 'Taille de police',
		colorModeModalMsg: 'Mode couleur',
		smaller: 'Petit',
		medium: 'Moyen',
		larger: 'Grand',
		largest: 'Plus grand',
		content_new: 'Nouveau contenu à proximité! Cliquez ici pour le voir.',
		content_current: 'Le contenu actuel est affiché.',
		toast_wrongCode: "'Désolé. Il n'y a pas de station pour ce numéro.",
		loading_text: 'Chargement du contenu ...',
		syncaudio_bar_text: "Synchroniser l'audio ...",
		toast_noAR: "Le contenu de l'AR n'est pas supporté. Merci d'utiliser l'application native!",
		back: 'Retour',
		cancel: 'Annuler',
		ok: 'OK',
		keyPadStationNumber: 'Entrer le numéro',
		keyPadEnterNumber: 'Entrez le numéro',
		keyPadWrongNumber: 'Numéro non trouvé',
		minutes: 'minutes',
		seconds: 'secondes',
		play: 'jouer',
		pause: 'pause',
		show: 'montrer',
		close: 'fermer',
		hide: 'cacher',
		download: 'Télécharger',
		downloading: 'En train de télécharger',
		waiting: 'En train d’attendre',
		update: 'Actualiser',
		delete: 'Supprimer',
		transcriptButtonTitle: 'Audio comme texte',
		next: 'prochain',
		previous: 'précédent',
		skip: 'sauter',
		previous: 'sauter',
		next: 'sauter',
		end: 'début',
		arWarningHeader: 'Faites attention à votre entourage!',
		arWarningText:
			"N'utilisez la réalité augmentée jamais dans des situations où une telle distraction vous empêche de percevoir votre environnement réel.",
		arWarningSubText:
			"Enfants ne peuvent pas utiliser la réalité augmentée que sous la surveillance d'un adulte.",
		arCoreKitWarningHeader: 'Attention',
		arCoreKitWarningText: 'Malheureusement, votre appareil ne supporte pas notre module AR actuel',
		understood: 'Je comprends',
		bright: 'Clair',
		dark: 'Foncé',
	},
	it: {
		langModalMsg: 'Scegli la tua lingua',
		fontSizeModalMsg: 'Grandezza del carattere',
		colorModeModalMsg: 'Modalità colore',
		smaller: 'Piccolo',
		medium: 'Medio',
		larger: 'Grande',
		largest: 'Maggiore',
		content_new: 'Nuovo contenuto nelle vicinanze! Clicca qui per vederlo. ',
		content_current: 'Viene visualizzato il contenuto corrente.',
		toast_wrongCode: "Scusa. Non c'è nessuna stazione per questo numero.",
		loading_text: 'Caricamento del contenuto ...',
		syncaudio_bar_text: 'Sincronizza audio ...',
		toast_noAR: "Il contenuto AR non è supportato. Si prega di utilizzare l'app nativa!",
		back: 'Indietro',
		cancel: 'Annulla',
		ok: 'OK',
		keyPadStationNumber: 'Inserisci il numero',
		keyPadEnterNumber: 'Inserire il numero',
		keyPadWrongNumber: 'Numero non trovato',
		minutes: 'minuti',
		seconds: 'secondi',
		play: 'gioca',
		pause: 'pausa',
		show: 'spettacolo',
		hide: 'nascondi',
		close: 'vicino',
		transcriptButtonTitle: 'Audio come testo',
		next: 'Il prossimo',
		previous: 'precedente',
		skip: 'salta',
		previous: 'indietro',
		next: 'continua',
		end: 'inizio',
		arWarningHeader: 'Attento a ciò che ti circonda!',
		arWarningText:
			'Non usate la Realtà Aumentata quando vi trovate in situazioni in cui tale distrazione vi impedisce di percepire il vostro ambiente reale.',
		arWarningSubText:
			'I bambini possono utilizzare la Realtà Aumentata solo sotto la supervisione di un adulto.',
		understood: 'Capisco',
		bright: 'Chiaro',
		dark: 'Scuro',
	},
	ja: {
		keyPadStationNumber: 'オブジェクト番号',
		keyPadEnterNumber: '番号を入力してください',
	},
	pt: {
		keyPadStationNumber: 'Introduzir número',
		keyPadEnterNumber: 'Número de objecto',
	},
	pl: {
		keyPadStationNumber: 'Wprowadź numer',
		keyPadEnterNumber: 'Numer obiektu',
	},
	ru: {
		keyPadStationNumber: 'номер объекта',
		keyPadEnterNumber: 'Введите номер',
	},
	sv: {
		name: 'Swedish',
		nativeName: 'Svenska',
		langModalMsg: 'Välj språk',
		fontSizeModalMsg: 'Teckenstorlek',
		colorModeModalMsg: 'Färg läge',
		smaller: 'Liten',
		medium: 'Medium',
		larger: 'Stor',
		largest: 'Större',
		content_new: 'Nytt innehåll i närheten! Klicka här för att se den. ',
		content_current: 'Nuvarande innehåll visas.',
		toast_wrongCode: 'Ledsen. Det finns ingen station för detta nummer. ',
		loading_text: 'Laddar innehåll ...',
		syncaudio_bar_text: 'Synkronisera ljud ...',
		toast_noAR: 'AR-innehåll stöds inte. Vänligen använd den inhemska appen! ',
		back: 'tillbaka',
		cancel: 'Avbryt',
		ok: 'OK',
		keyPadStationNumber: 'Ange stationsnummer',
		keyPadEnterNumber: 'Ange numret',
		keyPadWrongNumber: 'Station nummer hittades inte',
		minutes: 'minuter',
		seconds: 'sekunder',
		play: 'play',
		pause: 'paus',
		show: 'visa',
		hide: 'dölja',
		close: 'stänga',
		transcriptButtonTitle: 'Ljud som text',
		next: 'Nästa',
		previous: 'tidigare',
		skip: 'hoppa',
		previous: 'tillbaka',
		next: 'fortsätta',
		end: 'start',
		bright: 'Ljus',
		dark: 'Mörk',
	},
	tr: {
		keyPadStationNumber: 'Gayrimenkul numarası',
		keyPadEnterNumber: 'Numarayı girin',
	},
	uk: {
		keyPadStationNumber: 'Ввести номер експозиції',
		keyPadEnterNumber: 'Ввести номер',
		ok: 'Ок',
	},
};
